'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _CamTimeout = require('./CamTimeout');

var _CamTimeout2 = _interopRequireDefault(_CamTimeout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CamTimeout2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CamTimeout/index.js
// module id = 546
// module chunks = 11